import { useContext } from 'react'
import AgentsContext from './AgentsContext'
import type { AgentsContextType } from '../../types/agents'

/**
 * Hook to use agents context
 */
export function useAgents(): AgentsContextType {
  const context = useContext(AgentsContext)

  if (context === undefined) {
    throw new Error('useAgents must be used within an AgentsProvider')
  }

  return context
}
